import { render, staticRenderFns } from "./sidenavigation.vue?vue&type=template&id=4981731c"
import script from "./sidenavigation.vue?vue&type=script&lang=ts"
export * from "./sidenavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports